import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { FormControl, Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Form, Card, InputGroup } from 'react-bootstrap';

import ReactCountryFlag from "react-country-flag"
import carbonEodPricingInputs from './../json/carbonEodPricingInputs.json';

import {Tooltip} from 'react-tooltip';

// Data from JSON or DB
const peggedCountryList = {}
carbonEodPricingInputs[0].masterCountries.map(masterCountry => {
    masterCountry.peggedCountries.map(peggedCountry => {
        peggedCountryList[peggedCountry.properties.iso3] = peggedCountry.percentage;
    })
})


function CountryPeg(props) {
    // Setting original values (pick the prior day data from the DB or JSON file)
    const [state, setState] = useState(
        peggedCountryList
    )

    // Show or hide card based on onClick event
    const [hidden, setHidden] = useState(true);

    const handleChange = evt => {
        const name = evt.target.name;
        const value =
            evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
        setState({
            ...state,
            [name]: value
        })

        // Passing all values to parent class
        props["jsonResponseCountryPeg"]({ "name": name, "value": value });
    }


    return (
        <>
            <Card border="none" className="Card">
                <Card.Header className="Card-Header" style={{ cursor: 'pointer' }} onClick={() => setHidden(s => !s)}>Country peg (premium/discount)</Card.Header>
                {!hidden ? null :

                    <Card.Body className="Card-Body">

                        {carbonEodPricingInputs[0].masterCountries.map(masterCountry =>
                            masterCountry.peggedCountries.map(peggedCountry => <><div class="input-group flex-nowrap">
                                <div style={{ width: 55, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <label for="basic-url" className="form-label"><ReactCountryFlag
                                            countryCode={peggedCountry.properties.iso2}
                                            svg
                                            style={{ width: '2em' }}
                                            title={peggedCountry.properties.countryName}
                                        />
                                        </label> <span style={{ fontSize: "var(--module-font-size-smaller" }}>{peggedCountry.properties.iso3.toUpperCase()}{peggedCountry.properties.isLdc ? <a style={{ cursor: 'help' }} data-tip data-for='isLDC'>*</a> : ''}</span>
                                    </InputGroup>
                                </div>

                                <div style={{ width: 20, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                    <InputGroup size="sm" className="smaller-input justified-content-center">
                                        <a style={{ cursor: 'help' }} data-tip data-for='isPegged'><i className="bi bi-caret-right-fill"></i></a>
                                    </InputGroup>
                                </div>

                                <div style={{ width: 60, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <label for="basic-url" className="form-label"><ReactCountryFlag
                                            countryCode={masterCountry.properties.iso2}
                                            svg
                                            style={{ width: '2em', height: '1em' }}
                                            title={masterCountry.properties.countryName}
                                        />
                                        </label> <span style={{ fontSize: "var(--module-font-size-smaller" }}>{masterCountry.properties.iso3.toUpperCase()}</span>
                                    </InputGroup>
                                </div>

                                <div style={{ width: 90, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <FormControl name={peggedCountry.properties.iso3} value={state[peggedCountry.properties.iso3]} onChange={handleChange} type="number" step="1" style={{fontsize: "var(--module-font-size)"}}/>
                                        <InputGroup.Text style={{fontsize: "var(--module-font-size)"}}>%</InputGroup.Text>
                                    </InputGroup>
                                </div>

                            </div>

                            </>)
                        )}

                        <Tooltip id="isLDC" type="" place="right">
                            <span>Least Developed Country (LDC)</span>
                        </Tooltip>

                        <Tooltip id="isPegged" type="">
                            <span>is pegged to</span>
                        </Tooltip>


                    </Card.Body >
                }
            </Card >

        </>
    );

}


export default CountryPeg;